import { render, staticRenderFns } from "./RiskScenarioThreat.vue?vue&type=template&id=44bc63b1&scoped=true&"
import script from "./RiskScenarioThreat.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioThreat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc63b1",
  null
  
)

export default component.exports